// Port of api/fuel/app/classes/controller/api/monty/games/avatar.php
import DB from 'offline/db'
export default function(params) {
	var gameId = params.id || params.gameId
	var rows = gameId ? DB.query('SELECT game_avatar FROM game WHERE game_id = ?', [gameId]) : []
	return Promise.resolve({ session: { offline: true }, data: { avatar: rows.length ? rows[0].game_avatar : '' } })
}
